import { __module as isNumber } from '../../../../../_virtual/is-number.js';

var hasRequiredIsNumber;

function requireIsNumber () {
	if (hasRequiredIsNumber) return isNumber.exports;
	hasRequiredIsNumber = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isNumber;
		/**
		 * Check if a value is a number
		 * @ignore
		 * @param {*} value
		 * @return {boolean}
		 */
		function isNumber(value) {
		  return typeof value === 'number';
		}
		module.exports = exports['default'];
		
	} (isNumber, isNumber.exports));
	return isNumber.exports;
}

export { requireIsNumber as __require };
